module.exports = __webpack_public_path__ + "assets/img/button-blue.8a0e3671.png";